import { SVGProps, Ref, forwardRef } from 'react';

export const SkillPieAdvancedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8 4.667C5.5 4.667 4.667 6.333 4.667 8S5.5 11.333 8 11.333 11.333 9.667 11.333 8 10.5 4.667 8 4.667"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.667 8C2.667 5.333 4 2.667 8 2.667S13.333 5.333 13.333 8 12 13.333 8 13.333 2.667 10.667 2.667 8m1.2 0c0-1.155.29-2.181.888-2.898C5.32 4.423 6.288 3.867 8 3.867c1.711 0 2.68.556 3.245 1.235.597.717.888 1.743.888 2.898s-.29 2.182-.888 2.899c-.566.678-1.534 1.234-3.245 1.234s-2.68-.556-3.245-1.234c-.597-.717-.889-1.744-.889-2.899"
                fill="currentColor"
            />
        </g>
    </svg>
));
SkillPieAdvancedSize16Glyph.displayName = 'SkillPieAdvancedSize16Glyph';
